function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientTransform: "matrix(1 0 0 -1 -561.6 -3394.99)",
  gradientUnits: "userSpaceOnUse",
  x1: 863.508,
  x2: 755.497,
  y1: -3340.015,
  y2: -4045.088
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffd9d9",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9981,
  stopColor: "#ffb3b3"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "lg1"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff4d4d",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff4d4d",
  stopOpacity: 0
}));

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 256,
  x2: 256,
  xlinkHref: "#lg1",
  y1: 392.278,
  y2: 158.338
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 256,
  x2: 256,
  xlinkHref: "#lg1",
  y1: 144.94,
  y2: 46.333
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m338.919 70.183c-1.369 0-2.734.012-4.096.037-33.932.616-66.631-11.72-93.007-33.075-23.389-18.936-53.236-30.21-85.724-29.998-74.135.484-135.234 63.074-134.007 137.2.33 19.96 4.996 38.864 13.096 55.813 13.801 28.879 10.825 63.235-8.352 88.861-7.92 10.584-14.402 22.515-19.061 35.605-24.826 69.757 11.848 147.296 81.551 172.272 70.982 25.434 148.823-12.162 173.19-83.256 1.805-5.266 3.265-10.567 4.393-15.878 7.162-33.729 36.586-57.876 71.067-57.732.317.001.634.002.951.002 95.59 0 173.08-60.408 173.08-134.925s-77.492-134.926-173.081-134.926z",
  fill: "url(#SVGID_1_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m452.039 173.338v203.94c0 8.284-6.716 15-15 15h-362.08c-8.284 0-15-6.716-15-15v-203.94c0-8.284 6.716-15 15-15h362.08c8.284 0 15 6.715 15 15z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m418.999 158.338v210.18c0 5.523-4.477 10-10 10h-143c-2.76 0-5.26-1.12-7.07-2.93s-2.93-4.31-2.93-7.07c0 5.52-4.48 10-10 10h-143c-5.523 0-10-4.477-10-10v-210.18z",
  fill: "#4d4dff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m452.041 345.884h-392.086v-172.548c0-8.284 6.716-15 15-15h362.086c8.284 0 15 6.716 15 15z",
  fill: "#d9d9ff"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m255.999 161.548v189.42c0 5.52-4.48 10-10 10h-143c-5.52 0-10-4.48-10-10v-204.42c0-5.52 4.48-10 10-10h128c13.81 0 25 11.19 25 25z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m255.999 175v-13.452c0-13.81-11.19-25-25-25h-128c-5.52 0-10 4.48-10 10v28.452z",
  fill: "#ffc599"
}), /*#__PURE__*/React.createElement("path", {
  d: "m418.999 146.55v204.42c0 5.52-4.48 10-10 10h-143c-5.52 0-10-4.48-10-10v-189.42c0-13.81 11.19-25 25-25h128c5.52 0 10 4.48 10 10z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m255.999 275.667v75.301c0 5.523 4.477 10 10 10h142.999c5.523 0 10-4.477 10-10v-75.301z",
  fill: "#ebebff"
}))), /*#__PURE__*/React.createElement("path", {
  d: "m162.712 231.735v24.317c0 2.316 2.513 3.758 4.513 2.591l20.825-12.159c1.983-1.158 1.983-4.024 0-5.182l-20.825-12.159c-2.001-1.167-4.513.276-4.513 2.592z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ff6c6c"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 116.035,
  cy: 157.552,
  r: 4.286
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129.707,
  cy: 157.552,
  r: 4.286
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143.38,
  cy: 157.552,
  r: 4.286
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m168.527 315.835h-49.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h49.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff9494"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m195.527 333.338h-76.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h76.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#ff9494"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#ff9494"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 120.554,
  cy: 292.784,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136.804,
  cy: 292.784,
  r: 5
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m338.608 161.487c-28.338 0-51.393 23.054-51.393 51.392s23.055 51.392 51.393 51.392 51.392-23.054 51.392-51.392-23.054-51.392-51.392-51.392zm41.392 51.392c0 6.182-1.372 12.046-3.812 17.319-3.759-1.921-8.177-3.519-13.032-4.757.495-4.144.752-8.374.752-12.563 0-4.187-.256-8.416-.751-12.559 4.854-1.237 9.27-2.836 13.032-4.76 2.439 5.275 3.811 11.139 3.811 17.32zm-41.392 41.392c-3.17 0-6.915-4.059-9.774-10.592-1.343-3.068-2.457-6.534-3.326-10.288 4.192-.573 8.611-.88 13.101-.88 4.514 0 8.916.295 13.078.855-3.08 13.16-8.756 20.905-13.079 20.905zm0-31.76c-5.065 0-10.024.352-14.742 1.011-.369-3.432-.559-7-.559-10.643 0-3.759.205-7.311.567-10.642 4.722.661 9.681 1.01 14.734 1.01 5.063 0 10.021-.351 14.741-1.011.369 3.432.559 7 .559 10.643 0 3.759-.205 7.311-.567 10.642-4.721-.66-9.68-1.01-14.733-1.01zm-41.392-9.632c0-6.182 1.372-12.046 3.812-17.319 3.759 1.921 8.177 3.519 13.032 4.757-.495 4.144-.752 8.374-.752 12.563 0 4.187.256 8.415.751 12.557-4.854 1.238-9.267 2.839-13.03 4.764-2.441-5.274-3.812-11.139-3.813-17.322zm41.392-41.392c3.17 0 6.914 4.059 9.773 10.592 1.343 3.068 2.457 6.534 3.326 10.287-4.193.574-8.612.881-13.099.881-4.514 0-8.917-.295-13.078-.855 3.08-13.159 8.756-20.905 13.078-20.905zm32.288 15.536c-2.739 1.329-5.919 2.482-9.432 3.417-1.253-5.51-2.982-10.622-5.169-14.974 5.704 2.707 10.69 6.682 14.601 11.557zm-49.976-11.557c-2.19 4.359-3.921 9.481-5.175 15-3.502-.934-6.683-2.087-9.434-3.433 3.913-4.879 8.901-8.858 14.609-11.567zm-14.6 63.27c2.739-1.33 5.919-2.483 9.431-3.417 1.253 5.51 2.982 10.622 5.169 14.974-5.703-2.708-10.688-6.682-14.6-11.557zm49.976 11.557c2.19-4.359 3.921-9.481 5.174-15 3.502.934 6.683 2.087 9.434 3.433-3.912 4.879-8.901 8.858-14.608 11.567z",
  fill: "#6c6cff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m400.407 328.338c0 2.76-2.24 5-5 5h-113.28c-2.76 0-5-2.24-5-5s2.24-5 5-5h113.28c2.76 0 5 2.24 5 5z",
  fill: "#b3b3ff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m400.407 310.835c0 2.76-2.24 5-5 5h-113.28c-2.76 0-5-2.24-5-5s2.24-5 5-5h113.28c2.76 0 5 2.24 5 5z",
  fill: "#b3b3ff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m400.407 293.332c0 2.76-2.24 5-5 5h-113.28c-2.76 0-5-2.24-5-5s2.24-5 5-5h113.28c2.76 0 5 2.24 5 5z",
  fill: "#b3b3ff"
})), /*#__PURE__*/React.createElement("path", {
  d: "m452.039 173.338v203.94c0 8.284-6.716 15-15 15h-362.08c-8.284 0-15-6.716-15-15v-203.94c0-8.284 6.716-15 15-15h362.08c8.284 0 15 6.715 15 15z",
  fill: "url(#SVGID_2_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m243.399 360.968v54.81c0 4.02-4.5 6.39-7.82 4.13l-13.31-9.07-13.31 9.07c-3.32 2.26-7.82-.11-7.82-4.13v-54.81z",
  fill: "#ffc599"
}), /*#__PURE__*/React.createElement("path", {
  d: "m201.139 360.97h42.26v17.548h-42.26z",
  fill: "#ff9d33"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m359.709 136.55-5.42 15.92c-2.66 7.82-13.72 7.82-16.38 0l-5.41-15.92z",
  fill: "#ebebff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m421.999 46.333h-332c-5.523 0-10 4.477-10 10v48c0 5.523 4.477 10 10 10h239.499l8.413 24.741c2.66 7.822 13.723 7.822 16.383 0l8.413-24.741h59.292c5.523 0 10-4.477 10-10v-48c0-5.523-4.477-10-10-10z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m150.499 46.333h-60.5c-5.523 0-10 4.477-10 10v48c0 5.523 4.477 10 10 10h60.5z",
  fill: "#9494ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m102.205 95.274c.977.976 2.256 1.464 3.536 1.464s2.559-.488 3.536-1.464l6.677-6.677c1.824.815 3.782 1.237 5.745 1.237 3.601 0 7.201-1.371 9.942-4.111 5.482-5.482 5.482-14.402 0-19.884-5.482-5.481-14.401-5.481-19.884 0-4.235 4.235-5.184 10.518-2.874 15.687l-6.677 6.677c-1.954 1.953-1.954 5.119-.001 7.071zm16.622-22.363c.792-.792 1.831-1.188 2.871-1.188s2.079.396 2.871 1.188c1.583 1.583 1.583 4.158 0 5.741s-4.158 1.583-5.741 0-1.584-4.158-.001-5.741z",
  fill: "#2c27ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m337.499 88.872h-158.001c-2.761 0-5-2.239-5-5v-10.577c0-2.761 2.239-5 5-5h158.001c2.761 0 5 2.239 5 5v10.577c0 2.761-2.239 5-5 5z",
  fill: "#d9d9ff"
}))), /*#__PURE__*/React.createElement("path", {
  d: "m468.039 84.781c-1.279 0-2.56-.488-3.535-1.464l-4.465-4.464-4.465 4.464c-1.951 1.952-5.119 1.952-7.07 0-1.953-1.953-1.953-5.119 0-7.071l8-8c1.951-1.952 5.119-1.952 7.07 0l8 8c1.953 1.953 1.953 5.119 0 7.071-.975.976-2.256 1.464-3.535 1.464z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m326.308 442.667c-1.279 0-2.56-.488-3.535-1.464l-4.465-4.464-4.465 4.464c-1.951 1.952-5.119 1.952-7.07 0-1.953-1.953-1.953-5.119 0-7.071l8-8c1.951-1.952 5.119-1.952 7.07 0l8 8c1.953 1.953 1.953 5.119 0 7.071-.976.975-2.256 1.464-3.535 1.464z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m62.999 125.883h-3v-3c0-2.761-2.239-5-5-5s-5 2.239-5 5v3h-3c-2.761 0-5 2.239-5 5s2.239 5 5 5h3v3c0 2.761 2.239 5 5 5s5-2.239 5-5v-3h3c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m170.712 442.784h-3v-3c0-2.761-2.239-5-5-5s-5 2.239-5 5v3h-3c-2.761 0-5 2.239-5 5s2.239 5 5 5h3v3c0 2.761 2.239 5 5 5s5-2.239 5-5v-3h3c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
  fill: "#ff9d33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m208.527 467.174h-3v-3c0-2.761-2.239-5-5-5s-5 2.239-5 5v3h-3c-2.761 0-5 2.239-5 5s2.239 5 5 5h3v3c0 2.761 2.239 5 5 5s5-2.239 5-5v-3h3c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
  fill: "#8383ff"
}))), /*#__PURE__*/React.createElement("path", {
  d: "m421.999 46.333h-332c-5.523 0-10 4.477-10 10v48c0 5.523 4.477 10 10 10h239.499l8.413 24.741c2.66 7.822 13.723 7.822 16.383 0l8.413-24.741h59.292c5.523 0 10-4.477 10-10v-48c0-5.523-4.477-10-10-10z",
  fill: "url(#SVGID_3_)"
}));

function SvgEnrolledCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrolledCourse);
export default __webpack_public_path__ + "static/media/enrolled-course.32a06a3f.svg";
export { ForwardRef as ReactComponent };